"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Editor = void 0;
var react_1 = __importDefault(require("react"));
var editor_web_1 = require("@21st-night/editor-web");
var core_1 = require("@21st-night/core");
var styles_1 = require("@material-ui/styles");
var useStyles = styles_1.makeStyles(function () { return ({
    root: {
        position: 'relative',
        fontSize: '16px',
    },
    savingIndicator: {
        pointerEvents: 'none',
        position: 'absolute',
        top: 8,
        right: 8,
        borderRadius: 3,
        padding: '3px 6px',
        backgroundColor: '#F7F6F3',
        color: '#AFAEAA',
    },
}); });
var Editor = function (_a) {
    var children = _a.children, onChange = _a.onChange, value = _a.value, saving = _a.saving, plugins = _a.plugins, _b = _a.toolbar, toolbar = _b === void 0 ? true : _b, _c = _a.hoveringToolbar, hoveringToolbar = _c === void 0 ? true : _c, other = __rest(_a, ["children", "onChange", "value", "saving", "plugins", "toolbar", "hoveringToolbar"]);
    var classes = useStyles();
    var _d = core_1.useFirebase(), db = _d.db, storage = _d.storage, functions = _d.functions;
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement(editor_web_1.Editor, __assign({ db: db, storage: storage, functions: functions, imageUrl: process.env.REACT_APP_IMGIX_URL, onChange: onChange, value: value, plugins: plugins }, other),
            toolbar && react_1.default.createElement(editor_web_1.EditorToolbar, null),
            hoveringToolbar && react_1.default.createElement(editor_web_1.EditorHoveringToolbar, null),
            children),
        saving && react_1.default.createElement("span", { className: classes.savingIndicator }, "Saving...")));
};
exports.Editor = Editor;
//# sourceMappingURL=Editor.js.map